<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner  :slider="slider"/>
    <FuncShow :funInfo="funInfo" />
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    SliderBanner,
    Footer
  },
  data() {
    return {
      slider: {
        image: require('@/assets/images/index/block-chain/phone.png'),
        title: '区域链任务',
        desc: "制度模式下分为全球分红和区域代理板块，打造“团队作战、能者多得”的分销模式，实现销售业绩几何式增长…"
      },
      funInfo: {
        title: '区域链板块',
        list: [
          {
            title: '全球分红',
            img: require('@/assets/images/index/block-chain/img1.png'),
            text: '采用佣金等级+淘汰机制，激发分销积极性；团长带队，团员迅速成长为分销达人；自动绑定上下级关系，连锁商家也可用；团长可获得分销佣金和团队业绩分红。'
          },
          {
            title: '区域代理申请',
            img:  require('@/assets/images/index/block-chain/img2.png'),
            text: '成为某个地区下的代理，地区下的用户购买商品，该地区的代理能获取该订单的部分提成，赶快去申请吧'
          },
          {
            title: '区域代理中心',
            img:  require('@/assets/images/index/block-chain/img3.png'),
            text: '第一、代理商确立后，总部协助在其区域发展新的代理商、经销商；第二、代理商有权在代理区域内发展经销商，收取下属经销商的费用分成，并行使管理权；第三、供货差价利润；第四、所代理区域内所有专卖店的进货均计算为总经销的累计进货，并享受年终销售现金奖励。优秀的市级总代理有优先升级为省代的机会。'
          },
          {
            title: '代理网点',
            img:  require('@/assets/images/index/block-chain/img4.png'),
            text: '用户点击我要加入按钮可以加入附近的代理网点，或者选择自己想要代理的位置加入；用户也可以去创建自己的代理网点，选择网点位置，输入网点名称，就可以创建一个新代理网点。'
          },
          {
            title: '任务中心',
            img:  require('@/assets/images/index/block-chain/img5.png'),
            text: '用户在任务中心可以选择做某个任务，完成后可以获取佣金或积分，里面的任务种类繁多，比如每天签到、观看视频等'
          },
          {
            title: '区块链',
            img:  require('@/assets/images/index/block-chain/img6.png'),
            text: '区块链技术可以更加简单、高效和低成本的获取数据和资源，进而实现资源的有效整合，创造更多的经济和社会价值'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
